<template>
<div class="chapter">
<div class="inner_page">
<div class="galley-rw">
<section class="frontmatter-rw preface-rw auto-rw page-open-left-rw" epub:type="frontmatter preface" id="preface002">
<h1 class="preface-title"><a href="#/toc#toc-preface002"></a></h1><div class="sidebar">
<div class="ext_ch">
<div class="decoration-rw10">
<div class="media-rw image-rw float-none-rw floatgalley-none-rw align-center-rw width-fixed-rw exclude-print-rw">
<div class="pc-rw"><img alt="" class="orn1" src="images/Art_Pviii.jpg"/></div>
</div>
</div>
</div>
<p class="space-break">There was an old woman and she lived in the woods, weile weile waile.</p>
<p class="noindent">There was an old woman and she lived in the woods down by the river Saile.</p>
<p class="space-break">She had a baby three months old, weile weile waile.</p>
<p class="noindent">She had a baby three months old down by the river Saile.</p>
<p class="space-break">She had a penknife, long and sharp, weile weile waile.</p>
<p class="noindent">She had a penknife long and sharp down by the river Saile.</p>
<p class="space-break">She stuck the penknife in the baby’s heart, weile weile waile.</p>
<p class="noindent">She stuck the penknife in the baby’s heart down by the river Saile.</p>
<p class="space-break">Three hard knocks came knocking on the door, weile weile waile.</p>
<p class="noindent">Three hard knocks came knocking on the door down by the river Saile.</p>
<p class="space-break">“Are you the woman that killed the child?” weile weile waile.</p>
<p class="noindent">“Are you the woman that killed the child down by the river Saile?”</p>
<p class="space-break">The rope was pulled and she got hung, weile weile waile.</p>
<p class="noindent">The rope was pulled and she got hung down by the river Saile.</p>
<p class="space-break">And that was the end of the woman in the woods, weile weile waile.</p>
<p class="noindent">And that was the end of the woman in the woods down by the river Saile.</p>
<p class="ca">—traditional Irish murder ballad, ca. 1600</p>
</div></section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// preface002.vue?6bee16cc